<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Наименование"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <AddressStructuredField
          :value="v.address.$model"
          @change="v.address.$model = $event"
          :v="v.address"
          label="Адрес (место нахождения) организации"
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН организации"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <TrusteeView
          :v="v.trustee"
          :label="'Сведения о представителе иностранного юридического лица'"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import cloneDeep from 'clone-deep';
import TrusteeView, {
  trusteeModel,
  trusteeValidate,
} from '@/components/services/elements/TrusteeView';
import deepmerge from 'deepmerge';
import AddressStructuredField, {
  addressValidate,
} from '@/components/base/AddressStructuredField';

export const foreignOrganizationModel = {
  name: '',
  address: '',
  inn: '',
  trustee: cloneDeep(trusteeModel),
};

export const getForeignOrganizationValidation = (foreignOrganization) => ({
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  address: {
    required,
    ...addressValidate(),
  },
  inn: {
    required,
    maxLength: maxLength(10),
  },
  trustee: deepmerge(trusteeValidate(foreignOrganization.trustee), {
    email: {
      required,
    },
    phone: {
      required,
    },
  }),
});

export default {
  name: 'ForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    TrusteeView,
    AddressStructuredField,
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
